import { render, staticRenderFns } from "./LicenceRelation.vue?vue&type=template&id=b01843ac&scoped=true&"
import script from "./LicenceRelation.vue?vue&type=script&lang=js&"
export * from "./LicenceRelation.vue?vue&type=script&lang=js&"
import style0 from "./LicenceRelation.vue?vue&type=style&index=0&id=b01843ac&scoped=true&lang=css&"
import style1 from "./LicenceRelation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01843ac",
  null
  
)

export default component.exports